import { FormattedMessage } from 'react-intl';
import { cn } from '@/helpers/classnames';
import { getImportStateMeta } from '@/helpers/import';
import Button from '../core/Button';
import type { CollectionImportChangeDTO } from '@/api/trafikportalen';
import {
  formatFieldName,
  parseErrorMessage,
  translateErrorMessage,
} from './importRowUtils';
import { useIntl } from 'react-intl';

interface CollectionImportChangeListItemProps {
  change: CollectionImportChangeDTO;
  name?: string;
  nationalIdentityNumber?: string;
  onClick?: () => void;
}

export const CollectionImportChangeListItem = ({
  change,
  name,
  nationalIdentityNumber,
  onClick,
}: CollectionImportChangeListItemProps) => {
  const intl = useIntl();
  const { icon: Icon, textColor } = getImportStateMeta(change.action);

  return (
    <Button
      onClick={onClick}
      className={cn(
        'w-full flex-col items-start px-4 py-2 text-left text-base',
      )}
    >
      <div className="flex w-full gap-5">
        <div className="flex w-full flex-wrap gap-x-5">
          {nationalIdentityNumber && (
            <span className="text-nowrap font-mono text-text-700">
              {nationalIdentityNumber}
            </span>
          )}
          <div className="flex flex-1">
            {name ? (
              <span className="truncate text-nowrap text-text-950">{name}</span>
            ) : (
              <span className="italic text-text-500">
                <FormattedMessage defaultMessage="Namn saknas" />
              </span>
            )}
          </div>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <Icon className={cn('size-4', textColor)} />
          <span className={cn('text-base', textColor)}>
            <FormattedMessage id={`import.state.${change.action}`} />
          </span>
        </div>
      </div>
      {change.error_message && (
        <span className="text-red-700">
          {parseErrorMessage(change.error_message)
            .map(
              (error) =>
                `${formatFieldName(error.field)}: ${translateErrorMessage(intl, error)}`,
            )
            .join(', ')}
        </span>
      )}
    </Button>
  );
};
